export interface EninvoiceState {
    selectedPackageRestApiName: string;
    selectedBridgeRestApiName: string;
    selectedAppRestApiName: string;
    selectedReportName: string;
    selectedInstanceId: string;
    selectedRequestId: string;
    selectedRequestLogName: string;
}

export const eninvoiceState: EninvoiceState = {
    selectedPackageRestApiName: undefined,
    selectedAppRestApiName: undefined,
    selectedBridgeRestApiName: undefined,
    selectedReportName: undefined,
    selectedInstanceId: undefined,
    selectedRequestId: undefined,
    selectedRequestLogName: undefined,
};
